/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Planning assumptions - ability to disable a part of the planning business logic. 
 */
export interface PlanAssumptionsDelivery { 
    /**
     * Accounting for traffic during the route planning.
     */
    traffic_jams?: boolean;
    /**
     * Use toll roads.
     */
    toll_roads?: boolean;
    /**
     * Use ferry crossing.
     */
    ferry_crossing?: boolean;
    /**
     * Use for calculating straight line distances. If `false` is specified, distances are calculated by roads. When this parameter is enabled, traffic tracking (`traffic_jams`) is automatically disabled. 
     */
    flight_distance?: boolean;
    /**
     * Disable the accounting for capacity. If `true` is specified, all becomes compatible with everything. 
     */
    disable_compatibility?: boolean;
    /**
     * Disable the accounting for capacity. If `true` is specified, all vehicles can accommodate an unlimited cargo amount. 
     */
    disable_capacity?: boolean;
    /**
     * Use for calculation the same (specified) time window for orders and demands. The time window is specified from the beginning of the earliest window to the end of the latest window from all orders and demands. 
     */
    same_order_time_window?: boolean;
    /**
     * Expand the time window for performers\' and vehicle shifts.  The left border of the first shift extends to the left border of the specified window, right border extends to the right border or to the beginning of the next window for this entity. Each next shift moves the right border to the next shift or to the right border of the specified window. 
     */
    expand_shift_time_window?: boolean;
}

